videojs.addLanguage('en', {
	"Time left before start": "Time left before start",
	"Time left before webcast start": "Time left before webcast start",
	"Start time of video content" : "Start time",
	"Duration of video content" : "Duration",
	"Start time of webcast": "Start webcast time",
	"Duration of webcast" : "Webcast duration",
	"Min of content": "min",
	"Hours": "h",
	"Day": "day",
	"Days": "days",
	"Sdays": "days"
});
